import React from 'react';
// import PropTypes from 'prop-types';
import { BsGem } from 'react-icons/bs';
import Button from 'modules/common/Button';
import { useWallet } from '../hooks/useWallet';
import ErrorMessage from './ErrorMessage';

const dividerStyle = {
  position: 'relative',
  left: '-1px',
  clipPath: 'polygon(0 0, 100% 100%, 0 100%)',
};

function Wallet() {
  const [data, , error] = useWallet();

  const handleBuy = () => {
    window.location.href = '/buy-gems';
  };
  const [err, setErr] = React.useState(null);
  // const handleSell = () => {
  //   setErr({ message: 'This feature is not yet available.' });
  // };

  return (
    <>
      <ErrorMessage error={err} setError={setErr} />
      <div className="flex h-12">
        <div className="bg-primary-500 text-white pl-4 flex items-center">
          <div className="flex-shrink-0">
            <BsGem className="h-7 w-7" />
          </div>
          <div className="ml-2">
            {error ? (
              <div className="truncate font-black text-sm leading-none">
                {error?.message || 'Error'}
              </div>
            ) : (
              <div className="truncate font-black text-sm leading-none">
                {data?.balance || '0'}
              </div>
            )}
            <div className="text-[9px] whitespace-nowrap">Current Balance</div>
          </div>
        </div>
        <div className="bg-primary-500 w-20" style={dividerStyle} />
        <div className="flex flex-grow items-center justify-end pr-1">
          <div>
            <Button
              className="font-bold"
              transparent
              size="xs"
              onClick={handleBuy}
            >
              Buy Gems
            </Button>
          </div>
          {/* <div>
            <Button
              className="font-bold"
              transparent
              size="xs"
              onClick={handleSell}
            >
              Sell Gems
            </Button>
          </div> */}
        </div>
      </div>
    </>
  );
}

Wallet.propTypes = {};

export default Wallet;
